import { render, staticRenderFns } from "./shipmentRequestAdd.vue?vue&type=template&id=38271b84&scoped=true"
import script from "./shipmentRequestAdd.vue?vue&type=script&lang=js"
export * from "./shipmentRequestAdd.vue?vue&type=script&lang=js"
import style0 from "./shipmentRequestAdd.vue?vue&type=style&index=0&id=38271b84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38271b84",
  null
  
)

export default component.exports